import axios from "./axios";

export const customerinvoicesApi = {
  getCustomerInvoices: (params = {}) => {
    // Use projects/customer-invoices endpoint if project_id is provided
    if (params.project_id) {
      return axios.get(`/projects/${params.project_id}/customer-invoices`, { params });
    }
    // Use generic customer invoices endpoint
    return axios.get("/customer-invoices", { params });
  },

  getCustomerInvoice: (customerInvoiceId, params = {}) => {
    return axios.get(`/customer-invoices/${customerInvoiceId}`, { params });
  },

  createCustomerInvoice: (customerInvoice) => {
    return axios.post("/customer-invoices", {
      customerinvoice: customerInvoice,
    });
  },

  updateCustomerInvoice: (customerInvoiceId, customerInvoice) => {
    return axios.put(`/customer-invoices/${customerInvoiceId}`, {
      customerinvoice: customerInvoice,
    });
  },

  deleteCustomerInvoice: (customerInvoiceId) => {
    return axios.delete(`/customer-invoices/${customerInvoiceId}`);
  },
};

